/**
 * Method used to replace try catch statements, the reason behind it
 * is to not create scope variables inside a try catch block.
 */
var to = function to(promise) {
  return promise.then(function (data) {
    return [undefined, data];
  })["catch"](function (error) {
    return [error, undefined];
  });
};

/**
 * Method used to treat request-promise results
 */
var toRequest = function toRequest(promise) {
  return promise.then(function (data) {
    if (data.problem && !data.ok) {
      throw data;
    }
    return [undefined, data];
  })["catch"](function (error) {
    return [error, undefined];
  });
};
export { to, toRequest };